import { LauncherElement } from '../../types/launcherElement';

export const updateElementById = (
  elements: LauncherElement[],
  id: string,
  updatedElementData: any,
  parent: LauncherElement | null = null
): LauncherElement[] | null => {
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id === id) {
      elements[i] = { ...elements[i], ...updatedElementData };
      return elements;
    }

    const children = elements[i].props.children;
    if (children && children.length) {
      const updatedChildren = updateElementById(
        children,
        id,
        updatedElementData,
        elements[i]
      );

      if (updatedChildren !== null) {
        elements[i] = {
          ...elements[i],
          props: { ...elements[i].props, children: updatedChildren },
        };
        return elements;
      }
    }
  }

  return null;
};
